const yup = require("yup");

const maintainBalance = yup.object().shape({
  minimumBalance: yup
    .number()
    .positive("Amount must be positive")
    .required("Amount is required")
    .test(
      "is-two-decimal-places",
      "Amount must have at most two decimal places",
      function (value) {
        return /^\d+(\.\d{1,2})?$/.test(value);
      },
    ),
  targetBalance: yup
    .number()
    .positive("Amount must be positive")
    .required("Amount is required")
    .test(
      "is-two-decimal-places",
      "Amount must have at most two decimal places",
      function (value) {
        return /^\d+(\.\d{1,2})?$/.test(value);
      },
    )
    .test(
      "is-greater-than-minimum",
      "Target balance must be greater than or equal to minimum balance",
      function (value) {
        const { minimumBalance } = this.parent;
        return value >= minimumBalance;
      },
    ),
  confirmTransfer: yup.boolean(),
  memo: yup.string().optional(),
});

export default maintainBalance;
